<script>
  import solicitacaoCursoEventoMatricularServico from '../servico';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalLiberarInscricao from '~componentes/ModalLiberarInscricao.vue';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  export default {
    components: { ModalArquivosSolicitacao, ModalLiberarInscricao },
    data() {
      return {
        turma: this.camposTurma(),
        turmas: [],
        inscricoes: [],
        carregando: true,
        filtros: this.camposFiltros(),
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        modalArquivos: false,
        inscricaoSelecionada: null,
        utilizarArquivo: false,
        modalLiberarInscricao: false,
        matriculando: false,
        salvandoLiberacao: false,
        arrayColunas : new Array(0),
      }
    },
    computed: {
    },
    methods: {
      camposTurma() {
        return {
          idTurma: '',
          idTurmaInt: 0,
          nomeTurma: '',
          utilizarArquivo: false,
          numerosAlunosMaximo: '',
          numerosAlunosMinimo: '',
          numerosAlunos: '',
          numerosParcelas: '',
          valorParcela: 0,
          dataInicio: '',
          dataFinal: '',
          inicioInscricao: '',
          limiteInscricao: '',
        }
      },
      camposFiltros() {
        return {
          idTurma: '',
          idTurmaInt: 0,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#turma').val('0');
          $('#turma').trigger('change.select2');
        });

        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return solicitacaoCursoEventoMatricularServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.inscricoes = res.body.registros;
            if (this.inscricoes.length > 0)
              this.$set(this.turma, 'numerosAlunos', this.inscricoes[0].numerosAlunos)
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      async listaDeTurmas() {
        return solicitacaoCursoEventoMatricularServico
          .listaDeTurmas()
          .then(turmas => {
            this.turmas = turmas;
          });
      },
      mostrarModalArquivos(inscricao) {
        this.inscricaoSelecionada = inscricao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.inscricaoSelecionada = null;
      },
      setarTurma(id) {
        this.turmas.map(turma => {
          if (turma.idTurmaInt == id) {            
            this.$set(this, "utilizarArquivo", turma.utilizarArquivo);
            this.$set(this, 'turma', turma)
            this.$set(this.filtros, 'idTurma', turma.idTurma)
            this.$set(this.filtros, 'idTurmaInt', turma.idTurmaInt)
            this.$set(this, 'arrayColunas', new Array(turma.quantidadeMaxNotas))
          }
        });
      },
      mostrarModalLiberarCancelar(inscricao, matriculando) {
        this.inscricaoSelecionada = inscricao;
        this.modalLiberarInscricao = true;
        this.matriculando = matriculando;
      },
      matricular() {
        this.salvandoLiberacao = true;

        solicitacaoCursoEventoMatricularServico
          .matricular(this.inscricaoSelecionada.idInscricaoCript)
          .then(status => {
            this.modalLiberarInscricao = false;

            if (status.matriculado) {
              toastr.success(`Pedido de matricula do aluno realizado com sucesso.`);
            } else {
              toastr.warning(`Erro no pedido de matricula do aluno.`);
            }

            this.salvandoLiberacao = false;
            this.inscricaoSelecionada = null;
          })
          .then(this.lista);
      },
      desmatricular() {
        this.salvandoLiberacao = true;

        solicitacaoCursoEventoMatricularServico
          .desmatricular(this.inscricaoSelecionada.idInscricaoCript)
          .then(status => {
            this.modalLiberarInscricao = false;

            if (status.desmatriculado) {
              toastr.success(`Cancelamento do pedido de matricula do aluno realizado com sucesso`);
            } else {
              toastr.warning(`Erro no cancelamento do pedido de matricula do aluno.`);
            }

            this.salvandoLiberacao = false;
            this.inscricaoSelecionada = null;
          })
          .then(this.lista);
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarInscricao = false;
        this.inscricaoSelecionada = null;
      },
      gerarExcel() {
        return solicitacaoCursoEventoMatricularServico.listagemExcel(this.filtros)
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
    },
    created() {
      if (this.$route.params.filtrosBag) {
        this.$set(this.filtros, 'idTurma', this.$route.params.filtrosBag.idTurma)
        this.$set(this.filtros, 'idTurmaInt', this.$route.params.filtrosBag.idTurmaInt)

        this.listaDeTurmas()
          .then(_ => {
            this.setarTurma(this.filtros.idTurmaInt)
            $('.ibox').removeClass('collapsed');
          });      
      }

      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.lista();      
    },
    computed: {
      utilizarArquivamento() {
        return this.configuracao.usarArquivosInscricao && this.utilizarArquivo;
      }
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.$root.tituloDaPagina = 'Inscrições Alunos - Lista';    

      this.listaDeTurmas();
      $('.ibox').removeClass('collapsed');

      const _this = this;

      $('#turma').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idTurmaInt', this.value);
        _this.setarTurma(this.value)
        _this.lista(1);
      });

      if (this.$route.params.filtrosBag) {
        this.$set(this.filtros, 'idTurma', this.$route.params.filtrosBag.idTurma)
        this.$set(this.filtros, 'idTurmaInt', this.$route.params.filtrosBag.idTurmaInt)

        this.listaDeTurmas()
          .then(_ => {
            this.setarTurma(this.filtros.idTurmaInt)
            $('.ibox').removeClass('collapsed');
          });
      }          
    },
    watch: {
      
    },
  }
</script>

<style scoped>
  .checked {
    font-size: 1.40em;
    color: #1d9d74;
  }

  .cancelado {
    font-size: 1.40em;
    color: #ed5565;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-liberar-inscricao  :mostrar="modalLiberarInscricao"
                              :id="inscricaoSelecionada ? inscricaoSelecionada.idInscricaoCript : ''"
                              :salvando="salvandoLiberacao"
                              :matriculando="matriculando"
                              @fechado="modalLiberarCancelarFechado"
                              @matricular="matricular"
                              @desmatricular="desmatricular">
    </modal-liberar-inscricao>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="inscricaoSelecionada ? inscricaoSelecionada.idInscricaoCript : ''"
                                tipo="inscricao"
                                :idProtocolo="''"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="turma">Curso - Turma</label>

                  <select id="turma"
                          class="form-control"
                          v-model="filtros.idTurmaInt">
                    <option value="0">Selecionar</option>
                    <option :value="turma.idTurmaInt" v-for="(turma, index) in turmas">{{ turma.nomeTurma }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-content" v-if="turma.idTurma">
            <div class="row">
              <dl class="col-xs-3">
                <dt>Nº de alunos mínimo</dt>
                <dd>{{ turma.numerosAlunosMinimo || '---' }}</dd>
              </dl>

              <dl class="col-xs-3">
                <dt>Nº de alunos máximo</dt>
                <dd>{{ turma.numerosAlunosMaximo || '---' }}</dd>
              </dl>

              <dl class="col-xs-2">
                <dt>Nº de alunos</dt>
                <dd>{{ turma.numerosAlunos || '---' }}</dd>
              </dl>

              <dl class="col-xs-2" v-if="turma.numerosParcelas">
                <dt>Número parcelas</dt>
                <dd>{{ turma.numerosParcelas || '---' }}</dd>
              </dl>

              <dl class="col-xs-2" v-if="turma.valorParcela">
                <dt>Valor parcelas</dt>
                <dd>{{ turma.valorParcela | formatarNumero }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-2">
                <dt>Data início</dt>
                <dd>{{ turma.dataInicio || '---' }}</dd>
              </dl>

              <dl class="col-xs-2">
                <dt>Data fim</dt>
                <dd>{{ turma.dataFinal || '---' }}</dd>
              </dl>

              <dl class="col-xs-2">
                <dt>Início inscrição</dt>
                <dd>{{ turma.inicioInscricao || '---' }}</dd>
              </dl>

              <dl class="col-xs-2">
                <dt>Limite inscrição</dt>
                <dd>{{ turma.limiteInscricao || '---' }}</dd>
              </dl>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div class="row">
              <div class="col-xs-12">
                <button id="gerar-excel"
                        type="button"
                        class="btn btn-primary"
                        @click="gerarExcel"
                        data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                  <i class="fa fa-table"></i>
                  Gerar listagem em excel
                </button>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th class="text-center">Número</th>
                    <th class="text-center">Matricular</th>
                    <th class="text-center">Aluno</th>
                    <th class="text-center">Conta receber</th>
                    <th class="text-center">Arquivos</th>
                    <th>Data inscrição</th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Telefone</th>
                    <th>Categoria de valor</th>
                    <th>Valor inscrição</th>
                    <th v-for="(_, index) in arrayColunas" class="text-center">N{{ index + 1 }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(inscricao, index) in inscricoes">
                    <td class="text-center">{{ inscricao.idInscricao || '---' }}</td>
                    <td class="text-center"><i class="fa fa-check-circle-o checked" v-if="inscricao.matricular"></i></td>
                    <td class="text-center"><i class="fa fa-check-circle-o checked" v-if="inscricao.aluno"></i></td>
                    <td class="text-center">
                      <i class="fa fa-check-circle-o checked" v-if="inscricao.lancamento == 1" v-tooltip="'Recebida'"></i>
                      <i class="fa fa-ban cancelado" v-if="inscricao.lancamento == 2" v-tooltip="'Cancelada'"></i>
                    </td>
                    <td class="text-center"><i class="fa fa-check-circle-o checked" v-if="inscricao.arquivosAprovados"></i></td>
                    <td>{{ inscricao.dataInscricao || '---' }}</td>
                    <td>{{ inscricao.nome || '---' }}</td>
                    <td>{{ inscricao.email || '---' }}</td>
                    <td>{{ inscricao.celular ? inscricao.celular : inscricao.telefone  || '---' }}</td>
                    <td>{{ inscricao.categoria || '---' }}</td>
                    <td>{{ inscricao.valor | formatarNumero }}</td>
                    <td v-for="(_, index) in arrayColunas" class="text-center">{{ inscricao.notas[index] ? inscricao.notas[index].descricaoNota : '---' }}</td>
                    <td>
                      <router-link tag="button"
                                   class="btn btn-secondary btn-xs"
                                   active-class=""
                                   v-tooltip="'Editar'"
                                   :to="{ name: 'solicitacao-curso-evento-matricular.editar', params: { id: inscricao.idInscricao, idCript:  inscricao.idInscricaoCript, filtrosBag: filtros, utilizarArquivo : utilizarArquivamento } }">
                        <i class="fa fa-pencil"></i>
                      </router-link>

                      <button v-if="!inscricao.matricular && !inscricao.aluno"
                              class="btn btn-primary btn-xs"
                              v-tooltip="'Matrícular aluno'"
                              @click="mostrarModalLiberarCancelar(inscricao, true)">
                        <i class="fa fa-check"></i>
                      </button>

                      <button v-if="inscricao.matricular && !inscricao.aluno"
                              class="btn btn-danger btn-xs"
                              v-tooltip="'Desmatrícular aluno'"
                              @click="mostrarModalLiberarCancelar(inscricao, false)">
                        <i class="fa fa-trash"></i>
                      </button>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos da inscrição'"
                              @click="mostrarModalArquivos(inscricao, matriculando)"
                              v-if="utilizarArquivamento">
                        <i class="fa fa-archive"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="13">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/SolicitacaoCursoEventoMatricularLista.vue